import React, { FC } from 'react';

interface ICheckboxItem {
    id: string;
    name: string;
    label: string;
    isChecked: boolean;
    customStyles?: any;
    setFilterFormData: (state: any) => void;
    setFilterFormErrors: (state: any) => void;
}

const CheckboxItem: FC<ICheckboxItem> = ({ id, name, label, isChecked, setFilterFormData, setFilterFormErrors }: ICheckboxItem) => {
    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setFilterFormData((state: any) => {
                return {
                    ...state,
                    [event.target.name]: [ ...state[event.target.name], event.target.value ]
                }
            });

            setFilterFormErrors && setFilterFormErrors((state: any) => {
                return {
                    ...state,
                    [name]: '',
                }
            });
        } else {
            setFilterFormData((state: any) => {
                return {
                    ...state,
                    [event.target.name]: [ ...state[event.target.name].filter((item: string) => item !== event.target.value) ]
                }
            });
        }
    };

    return (
        <div className="multiple-select__checkbox-item">
            <label
                className="multiple-select__checkbox-item-label"
                htmlFor={id}
            >
                <span className="multiple-select__checkbox-label-text">{label}</span>
                <input
                    className="multiple-select__checkbox-input"
                    type="checkbox"
                    id={id}
                    name={name}
                    value={label}
                    checked={isChecked}
                    onChange={onChangeHandler}
                />
                <div className="multiple-select__checkbox-checkmark"/>
            </label>
        </div>
    );
};

export default React.memo(CheckboxItem);
